module.exports = __webpack_public_path__ + "img/BARE BOARD LOADER(VACUUM PICK-UP TYPE).2894bbf0.jpg";